<template>
  <page>
    <sidebar slot="sidebar"/>
    <span slot="header">Access Requests</span>
    <b-tabs card no-fade>
      <b-tab title="Pending" active>
        <pending/>
      </b-tab>
      <b-tab title="Declined">
        <declined/>
      </b-tab>
      <b-tab title="Archived">
        <archived/>
      </b-tab>
    </b-tabs>
  </page>
</template>

<script>
import page from '../../../templates/page'
import sidebar from '../../../sidebar'
import pending from './pending'
import declined from './declined'
import archived from './archived'

export default {
  components: {
    pending,
    declined,
    archived,
    sidebar,
    page
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/access-requests/index.vue